<script setup></script>

<template>
	<section class="hero">
		<div class="hero__bg">
			<picture>
				<source srcset="@/assets/img/hero/hero_bg.png" media="(min-width: 991.98px)" />
				<img loading="lazy" src="@/assets/img/hero/hero_bg--min.png" alt="" />
			</picture>
		</div>
		<div class="hero__bg-elem hero_bg-elem-left">
			<img loading="lazy" src="@/assets/img/hero/hero_bg-gif-left.gif" alt="" />
		</div>
		<div class="hero__bg-elem hero_bg-elem-right">
			<img loading="lazy" src="@/assets/img/hero/hero_bg-gif-right.gif" alt="" />
		</div>
		<div class="hero__bg-elem hero_bg-elem-bottom-right">
			<img loading="lazy" src="@/assets/img/hero/hero_bg-elem-tape.png" alt="" />
		</div>
		<div class="hero__container">
			<div class="hero__content">
				<h1 class="visually-hidden">Маски 360°</h1>

				<router-link :to="{ path: '/', hash: `#reviews` }" class="hero__btn">
					<span class="hero__btn_icon">
						<svg width="44" height="44">
							<use :href="`#play`" />
						</svg>
					</span>
					<span class="hero__btn_text">Видео-отзывы</span>
				</router-link>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.hero {
	position: relative;
	height: 96.6rem;
	overflow: hidden;

	@media (max-width: 1169.98px) {
		height: 75rem;
	}

	@media (max-width: 991.98px) {
		height: 66.6rem;
		margin-top: -8rem;
	}

	// .hero__bg
	&__bg {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 50%;
		top: 0rem;
		transform: translateX(-50%);
		z-index: -2;
		pointer-events: none;
		user-select: none;

		@media (max-width: 991.98px) {
			width: 215%;
			height: 101%;
			left: 54.5%;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
			object-position: bottom;
		}
	}

	// .hero__bg-elem
	&__bg-elem {
		position: absolute;
		pointer-events: none;
		user-select: none;
		z-index: -1;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	// .hero_bg-elem-left
	&_bg-elem-left {
		mix-blend-mode: plus-lighter;
		top: 28.5rem;
		left: 23rem;
		width: 16.4rem;

		@media (max-width: 1169.98px) {
			top: 20rem;
		}

		@media (max-width: 991.98px) {
			width: 4rem;
			top: 12.6rem;
			left: 5.8rem;
		}
	}

	// .hero_bg-elem-right
	&_bg-elem-right {
		mix-blend-mode: plus-lighter;
		top: 11.5rem;
		right: 26.5rem;
		transform: rotate(14deg);
		width: 15rem;

		@media (max-width: 1169.98px) {
			top: 10rem;
			right: 15rem;
		}

		@media (max-width: 991.98px) {
			transform: rotate(21deg);
			width: 5rem;
			top: 12.2rem;
			right: 2rem;
		}
	}

	// .hero_bg-elem-right
	&_bg-elem-bottom-right {
		bottom: 0;
		right: 0;
		width: 16.8rem;

		@media (max-width: 991.98px) {
			width: 7.3rem;
		}
	}

	// .hero__container
	&__container {
		height: 100%;
	}

	// .hero__content
	&__content {
		position: relative;
		height: 100%;
	}

	// .hero__wrapper
	&__wrapper {
		height: 100%;
	}

	// .hero__btn
	&__btn {
		position: absolute;
		z-index: 100;
		bottom: 20rem;
		left: 9rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		gap: 2rem;

		@media (max-width: 991.98px) {
			bottom: 2.5rem;
			left: 0;
			flex-direction: row;
			justify-content: center;
			width: 100%;
		}

		@media (any-hover: hover) {
			&:hover {
				.hero__btn_icon {
					background-color: var(--second-color);

					&::after {
						border-color: var(--second-color);
					}
				}
				.hero__btn_text {
					transform: rotate(-6deg);
				}
			}
		}

		// .hero__btn_icon
		&_icon {
			flex-shrink: 0;
			width: 10rem;
			height: 10rem;
			border-radius: 50%;
			background-color: var(--primary-color);
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			transition: background-color 0.3s ease 0s;

			svg {
				width: 4.4rem;
				height: 4.4rem;
			}

			@media (max-width: 991.98px) {
				width: 5rem;
				height: 5rem;

				svg {
					width: 2.2rem;
					height: 2.2rem;
				}
			}

			&::after {
				content: '';
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				border-radius: inherit;
				width: 100%;
				height: 100%;
				border: 1px solid var(--primary-color);
				animation: pulse 2s linear infinite both;
				pointer-events: none;
				transition: border-color 0.3s ease 0s;

				@keyframes pulse {
					0% {
						transform: translate(-50%, -50%) scale(1);
						opacity: 1;
					}
					100% {
						transform: translate(-50%, -50%) scale(1.3);
						opacity: 0;
					}
				}
			}
		}

		// .hero__btn_text
		&_text {
			display: block;
			font-weight: 600;
			font-size: 2.4rem;
			// line-height: 2.8rem;
			line-height: 116%;
			text-align: center;
			font-family: var(--second-font);
			transition: transform 0.3s ease 0s;

			@media (max-width: 991.98px) {
				font-size: 1.8rem;
			}
		}
	}
}
</style>
